import { render } from "./LiquidacionOperarios.vue?vue&type=template&id=825daf7e"
import script from "./LiquidacionOperarios.vue?vue&type=script&lang=js"
export * from "./LiquidacionOperarios.vue?vue&type=script&lang=js"

import "./LiquidacionOperarios.vue?vue&type=style&index=0&id=825daf7e&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__